module.exports = __webpack_public_path__ + "img/ac-milan.47e6b0de.png";